'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { getUtk, UNKNOWN_UTK } from '../util/Cookies';
import { createClient } from 'laboratory-lib';
import { makeLaboratoryHooks } from 'cms-growth-lib/laboratory/factories/makeLaboratoryHooks';
var identifier = getUtk() || UNKNOWN_UTK;
export var TREATMENT_KEY_CGFE_005 = 'cgfe-005';

var TREATMENTS_SCHEMA = _defineProperty({}, TREATMENT_KEY_CGFE_005, {
  key: TREATMENT_KEY_CGFE_005,
  identifier: identifier,
  parameters: {
    ctaopt: ['trial', 'starter']
  }
});

var laboratoryClient = createClient({
  quickFetchLabel: 'experiment-treatments',
  treatments: TREATMENTS_SCHEMA,
  timeout: identifier === UNKNOWN_UTK ? 0 : 8000
});

var _makeLaboratoryHooks = makeLaboratoryHooks(laboratoryClient),
    TreatmentContext = _makeLaboratoryHooks.TreatmentContext,
    TreatmentProvider = _makeLaboratoryHooks.TreatmentProvider,
    useTreatment = _makeLaboratoryHooks.useTreatment;

export { TreatmentContext, TreatmentProvider, useTreatment };